import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "pb-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Investment Thesis ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-6" }, " Please share your investment thesis populating the field items below. This information would help in sharing suitable investment opportunities that are a close fit. ", -1)
const _hoisted_5 = {
  key: 0,
  class: "text-gray-400 fw-bold fs-6 mt-3"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { id: "investment-ticket-size" }, null, -1)
const _hoisted_7 = { class: "fv-row mb-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Currency", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: "pound"
}, "£ (Pounds Sterling)", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: "dollar" }, "$ (US Dollars)", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: "euro" }, "€ (Euros)", -1)
const _hoisted_12 = { class: "row mb-10" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Minimum Investment", -1)
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Maximum Investment", -1)
const _hoisted_17 = { class: "row mb-10" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Stage of Evolution", -1)
const _hoisted_20 = ["onUpdate:modelValue", "name"]
const _hoisted_21 = {
  class: "form-check-label",
  for: "flexCheckDefault"
}
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Minimum Traction", -1)
const _hoisted_24 = ["onUpdate:modelValue", "name"]
const _hoisted_25 = {
  class: "form-check-label",
  for: "flexCheckDefault"
}
const _hoisted_26 = { class: "row mb-10" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Geo Focus", -1)
const _hoisted_29 = ["onUpdate:modelValue", "name"]
const _hoisted_30 = {
  class: "form-check-label",
  for: "flexCheckDefault"
}
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tax Relief Status", -1)
const _hoisted_33 = ["onUpdate:modelValue", "name"]
const _hoisted_34 = {
  class: "form-check-label",
  for: "flexCheckDefault"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (_ctx.fromUpdateInvestor)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Alternatively, you can skip this step by clicking on the \"Skip and View Investment Opportunity\" and return to register at a later stage. "))
        : _createCommentVNode("", true)
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode(_component_Field, {
        modelValue: _ctx.currencyCode,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currencyCode) = $event)),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fieldChanged($event))),
        name: "currencyCode",
        class: "form-select form-select-lg form-select-solid",
        "data-control": "select2",
        "data-placeholder": "Select...",
        "data-allow-clear": "true",
        "data-hide-search": "true",
        as: "select"
      }, {
        default: _withCtx(() => [
          _hoisted_9,
          _hoisted_10,
          _hoisted_11
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_ErrorMessage, {
        name: "currencyCode",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode(_component_Field, {
          as: "input",
          type: "text",
          onInput: _cache[2] || (_cache[2] = ($event: any) => {
            _ctx.fieldChanged($event);
            _ctx.formatInput($event);
          }),
          name: "minInvestment",
          class: "form-control form-control-lg form-control-solid",
          modelValue: _ctx.minInvestment,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.minInvestment) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "minInvestment",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createVNode(_component_Field, {
          as: "input",
          type: "text",
          onInput: _cache[4] || (_cache[4] = ($event: any) => {
            _ctx.fieldChanged($event);
            _ctx.formatInput($event);
          }),
          name: "maxInvestment",
          class: "form-control form-control-lg form-control-solid",
          modelValue: _ctx.maxInvestment,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.maxInvestment) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "maxInvestment",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stageOfEvolution, (i, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `soe-${index}`,
            class: "form-check form-check-custom form-check-solid my-3"
          }, [
            _withDirectives(_createElementVNode("input", {
              onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fieldChanged($event))),
              "onUpdate:modelValue": ($event: any) => ((i.value) = $event),
              class: "form-check-input",
              type: "checkbox",
              name: i.name,
              id: "flexCheckDefault"
            }, null, 40, _hoisted_20), [
              [_vModelCheckbox, i.value]
            ]),
            _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.enums[i.name]), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.minimumTraction, (i, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `mt-${index}`,
            class: "form-check form-check-custom form-check-solid my-3"
          }, [
            _withDirectives(_createElementVNode("input", {
              onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.fieldChanged($event))),
              "onUpdate:modelValue": ($event: any) => ((i.value) = $event),
              class: "form-check-input",
              type: "checkbox",
              name: i.name,
              id: "flexCheckDefault"
            }, null, 40, _hoisted_24), [
              [_vModelCheckbox, i.value]
            ]),
            _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.enums[i.name]), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.geoFocus, (i, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `gf-${index}`,
            class: "form-check form-check-custom form-check-solid my-3"
          }, [
            _withDirectives(_createElementVNode("input", {
              onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.fieldChanged($event))),
              "onUpdate:modelValue": ($event: any) => ((i.value) = $event),
              class: "form-check-input",
              type: "checkbox",
              name: i.name,
              id: "flexCheckDefault"
            }, null, 40, _hoisted_29), [
              [_vModelCheckbox, i.value]
            ]),
            _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.enums[i.name]), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_31, [
        _hoisted_32,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taxReliefStatus, (i, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `trs-${index}`,
            class: "form-check form-check-custom form-check-solid my-3"
          }, [
            _withDirectives(_createElementVNode("input", {
              onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.fieldChanged($event))),
              "onUpdate:modelValue": ($event: any) => ((i.value) = $event),
              class: "form-check-input",
              type: "checkbox",
              name: i.name,
              id: "flexCheckDefault"
            }, null, 40, _hoisted_33), [
              [_vModelCheckbox, i.value]
            ]),
            _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.enums[i.name]), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}